import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { buyModalShow } from "../../redux/counterSlice";
import Likes from "../likes";
import { timeAgo } from "../../utils/filters";
export const baseURL = `https://devapi.impactoverse.com/`;
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "tippy.js/dist/tippy.css";

const Post_item = ({
  data,
  classes = "grid grid-cols-1 gap-[1.875rem] sm:grid-cols-2 md:grid-cols-3",
}) => {
  const dispatch = useDispatch();
  return (
    <>
      <div className={classes}>
        {data.slice(1).map((item) => {
          const { _id, assets, discription, text, createdAt, } = item;
          const dateTime = new Date(createdAt);

          const date = `${dateTime.getFullYear()}-${(dateTime.getMonth() + 1).toString().padStart(2, '0')}-${dateTime.getDate().toString().padStart(2, '0')}`;
          const time = timeAgo(dateTime);
          return (
            <article key={_id}>
              <div className="rounded-2xl overflow-hidden transition-shadow hover:shadow-lg">
                <figure className="group overflow-hidden ">
                  <Link href={`/single_post/post_1`}>
                    {/* <Image
                      width={370} 
                      height={214}
                      src={baseURL+assets[0]}
                      alt={discription}
                      className="h-full w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 "
                      style={{height:'209px'}}
                    /> */}
                    <Swiper
                      loop={true}
                     navigation={true}
                      centeredSlides={true}
                      spaceBetween={30}
                      slidesPerView={'auto'}
                      modules={[Navigation]}
                      autoplay={{
                        delay: 5000,
                        disableOnInteraction: false,
                      }}
                      className="  full-slider-thumbs swiper-initialized swiper-horizontal swiper-pointer-events swiper-thumbs"
                    >
                      {
                        assets?.map((image, index) => {
                          return (
                            <SwiperSlide
                              className="swiper-slide swiper-slide-center cursor-pointer rounded p-5 swiper-slide-duplicate swiper-slide-duplicate-next "
                              key={index}
                            >
                              <Image
                                width={132}
                                height={77}
                                src={`${baseURL}${image}`}
                                className=" object-cover rounded-lg"
                                alt="thumb 1"
                                style={{ height: "77px" }}
                              />
                              <div className="carousel-progress relative -bottom-5 z-10 -ml-5 -mr-5 h-0.5 bg-white/20 ">
                                <div className="progress bg-accent absolute h-0.5 w-0"></div>
                              </div>
                            </SwiperSlide>
                          );
                        })
                      }
                    </Swiper>
                  </Link>
                </figure>

                {/* <!-- Body --> */}
                <div className="dark:border-jacarta-600 dark:bg-jacarta-700 border-jacarta-100 rounded-b-[1.25rem] border border-t-0 bg-white p-[10%]">
                  {/* <!-- Meta --> */}

                  <h2 className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white">
                    <Link href={`single_post/post_1}`}>{discription}</Link>
                  </h2>
                  <p className="dark:text-jacarta-200 mb-8">{discription}</p>

                  {/* <!-- Date / Time --> */}
                  <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm">
                    <span>
                      <time>{date}</time>
                    </span>
                    <span>•</span>
                    <span>{time}</span>
                  </div>
                  <div className="text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm mt-2">
                    <Likes like="25" classes="flex items-center space-x-1" />
                    <span>•</span>
                    <span>
                      <button
                        className="text-accent font-display text-sm font-semibold"
                        onClick={() => dispatch(buyModalShow())}
                      >
                        Comment
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </>
  );
};

export default Post_item;
